export const environment = {
  production: true,
  // api: "http://192.168.1.110:9999/"
  // api: "http://localhost:9999/"
  // api: "http://192.168.1.21:9999/"
  api: "https://api.liceolumen.com/"
};
